import { localStorage } from 'dibs-browser-storage';

export const FORCE_FAVORITE_ITEM_ID = 'FORCE_FAVORITE_ITEM_ID' as const;
export const FORCE_FOLDER_ITEM_ID = 'FORCE_FOLDER_ITEM_ID' as const;

export function getForceFavoriteItemId(key: string): JsonType {
    return localStorage.getItem(key);
}

export function setForceFavoriteItemId(key: string, itemId: string): void {
    localStorage.setItem(key, itemId);
}

export function clearForceFavoriteItemId(key: string): void {
    localStorage.deleteItem(key);
}
